import { Switch, Route, Redirect } from 'react-router-dom';

import PageGuard from 'components/PageGuard';
import ErrorBoundary from 'components/ErrorBoundary';

import OnboardingPage from 'pages/Onboarding';
import GrabAccountLinkPage from 'pages/GrabAccountLink';

import PrivacyPolicyPage from 'pages/PrivacyPolicy';
import LoginPage from 'pages/Login';
import PhoneNumberVerificationFailed from 'pages/PhoneNumberVerificationFailed';
import RegisterPage from 'pages/Register';
import OTPPage from 'pages/Otp';

import CreatePINPage from 'pages/PIN/CreatePIN';
import ForgotPinPage from 'pages/PIN/ForgotPin';
import InputPINPage from 'pages/PIN/InputPIN';
import ChangePinPage from 'pages/PIN/ChangePin';

import Homepage from 'pages/Homepage';

import LoanOffer from 'pages/NewLoanOffer';

import {
  AgreementLetter as AgreementLetterPage,
  AgreementSummary as AgreementSummaryPage,
  DigitalSignature as DigitalSignaturePage,
  PrivyRegistration as PrivyRegistrationPage,
} from 'pages/LoanProcess';
import PrivyOTPInputPage from 'pages/Home/LoanProcess/PrivyOTPInput';
import PrivySuccessSigningPage from 'pages/Home/LoanProcess/PrivySuccessSigning';
import PrivyWaitingPage from 'pages/Home/LoanProcess/PrivyWaiting';

import LoanHistoryPage from 'pages/LoanServicing/LoanHistory';
import LoanHistoryDetailPage from 'pages/LoanServicing/LoanHistoryDetail';
import LoanDetailPaymentHistory from 'pages/LoanServicing/LoanHistoryDetail/PaymentHistory';
import PaymentHistory from 'pages/LoanServicing/PaymentHistory';

import AccountPage from 'pages/Account';
// import ReferralPage from 'pages/Home/Referral';
import ProfilePage from 'pages/Profile';
import ChangeEmailPage from 'pages/Home/ChangeEmail';
import ChangePhonePage from 'pages/Home/ChangePhone';
import ChangePhoneEmailPage from 'pages/ChangePhone/ChangePhoneForm/WithEmail';
import ChangePhoneWebviewPage from 'pages/ChangePhone/ChangePhoneForm/WithPhone';
import InputOtpPage from 'pages/Home/InputOtp';
import InputOldPinPage from 'pages/Home/InputOldPin';

import TermsPage from 'pages/Terms';
import FaqPage from 'pages/Faq';
import AboutPage from 'pages/About';
import HelpPage from 'pages/HelpCenter';
import NeedHelpPage from 'pages/NeedHelp';
import MaintenancePage from 'pages/Maintenance';
import NewApplication from 'pages/Home/NewApplication';
import ChangeBankAccount from 'pages/ChangeBankAccount';
import Checkout from 'pages/Checkout';
import UpdateEmergencyContact from 'pages/UpdateEmergencyContact';
import EmergencyContactConsent from 'pages/EmergencyContactConsent';
import ChangePhoneInstruction from 'pages/ChangePhone/ChangePhoneInstruction';
import UpdateUserInformation from 'pages/UpdateUserInformation';

import './App.scss';

import ReactGA from 'react-ga4';
import { GA4_JULO, APP_ENV } from 'configs';

if (APP_ENV == 'production') {
  ReactGA.initialize(GA4_JULO);
}

function App() {
  return (
    <ErrorBoundary>
      <Switch>
        <Route exact path='/' component={OnboardingPage} />
        <Route
          exact
          path='/grab_account_link'
          component={GrabAccountLinkPage}
        />
        <Route exact path='/otp' component={OTPPage} />
        <Route exact path='/privacy_policy' component={PrivacyPolicyPage} />
        <Route exact path='/login' component={LoginPage} />
        <Route
          exact
          path='/verification_failed'
          component={PhoneNumberVerificationFailed}
        />
        <Route exact path='/pin' component={InputPINPage} />

        <Route exact path='/register' component={RegisterPage} />
        <Route exact path='/create_pin' component={CreatePINPage} />

        <Route exact path='/forgot_pin' component={ForgotPinPage} />

        <Route exact path='/change_pin' component={PageGuard(ChangePinPage)} />

        <Route exact path='/offer' component={LoanOffer} />

        <Route
          exact
          path='/application'
          component={PageGuard(NewApplication)}
        />
        <Redirect from='/application/:step' to='/application' />

        <Route exact path='/home' component={PageGuard(Homepage)} />
        <Route
          exact
          path='/update-emergency-contact'
          component={PageGuard(UpdateEmergencyContact)}
        />
        <Route
          exact
          path='/emergency-contact-:id'
          component={EmergencyContactConsent}
        />
        <Route
          exact
          path='/agreement_summary'
          component={AgreementSummaryPage}
        />
        <Route
          exact
          path='/agreement_summary/:loanXid/signature'
          component={DigitalSignaturePage}
        />
        <Route
          exact
          path='/agreement_summary/:loanXid/:docType'
          component={AgreementLetterPage}
        />
        <Route
          exact
          path='/agreement_letter/:loanXid/:docType'
          component={AgreementLetterPage}
        />
        <Route exact path='/privy_otp_input' component={PrivyOTPInputPage} />
        <Route
          exact
          path='/privy_success_signing'
          component={PrivySuccessSigningPage}
        />
        <Route exact path='/privy_waiting' component={PrivyWaitingPage} />
        <Route
          exact
          path='/loan_history'
          component={PageGuard(LoanHistoryPage)}
        />
        <Route
          exact
          path='/payment_history'
          component={PageGuard(PaymentHistory)}
        />
        <Route
          exact
          path='/loan_history/:id'
          component={PageGuard(LoanDetailPaymentHistory)}
        />
        <Route
          exact
          path='/loan_history/:loanXid/:docType'
          component={PageGuard(AgreementLetterPage)}
        />
        <Route
          exact
          path='/loan_history_details'
          component={LoanHistoryDetailPage}
        />
        <Route exact path='/account' component={PageGuard(AccountPage)} />
        {/* <Route
        exact
        path='/account/referral'
        component={PageGuard(ReferralPage)}
      /> */}
        <Route exact path='/profile' component={PageGuard(ProfilePage)} />
        <Route
          exact
          path='/change_email'
          component={PageGuard(ChangeEmailPage)}
        />
        <Route
          exact
          path='/change_phone'
          component={PageGuard(ChangePhonePage)}
        />
        <Route
          exact
          path='/home/change_phone'
          component={PageGuard(ChangePhonePage)}
        />
        <Route
          exact
          path='/change-phone-email'
          component={PageGuard(ChangePhoneEmailPage)}
        />
        <Route
          exact
          path='/change-phone-webview'
          component={ChangePhoneWebviewPage}
        />
        <Route exact path='/home/input_otp' component={InputOtpPage} />
        <Route exact path='/input_otp' component={InputOtpPage} />
        <Route
          exact
          path='/home/input_pin'
          component={PageGuard(InputOldPinPage)}
        />
        <Route exact path='/input_pin' component={PageGuard(InputOldPinPage)} />

        <Route exact path='/terms' component={TermsPage} />
        <Route exact path='/faq' component={FaqPage} />
        <Route exact path='/about' component={AboutPage} />
        <Route exact path='/help' component={HelpPage} />
        <Route exact path='/need_help' component={NeedHelpPage} />

        <Route exact path='/maintenance' component={MaintenancePage} />
        <Route
          exact
          path='/update-user-information'
          component={UpdateUserInformation}
        />

        <Route
          exact
          path='/change-bank'
          component={PageGuard(ChangeBankAccount)}
        />
        <Route exact path='/checkout' component={Checkout} />
        <Route
          exact
          path='/home/change-bank'
          component={PageGuard(ChangeBankAccount)}
        />
        <Route
          exact
          path='/change-phone-instruction'
          component={ChangePhoneInstruction}
        />
        <Route
          exact
          path='/privy-registration'
          component={PrivyRegistrationPage}
        />
      </Switch>
    </ErrorBoundary>
  );
}

export default App;
